import { Vector3 } from 'three';
import { WxShape } from './wx-shape';
import { ExportToolUtils } from '../export-tool-utils';
import { WxEnvelopeVO } from '@article/model/vo/wx-article.vo';
import { MathUtils } from '@3d-scene/common/util/math-utils';

export class WxEnvelope extends WxShape {
  public envelopeId: number;
  public points: Vector3[];

  public constructor(element: WxEnvelopeVO) {
    super();
    this.envelopeId = element.envelopeId;
    this.closed = true;
    this.points = [];
    for (const point of element.points) {
      this.points.push(new Vector3(0, point.y, point.z));
    }
  }

  public getPoints(): Vector3[] {
    const points: Vector3[] = [];
    for (const point of this.points) {
      const num: Vector3 = ExportToolUtils.translateToConfiguratorCoords(point.x, point.y, point.z);
      if (!this.contains(points, num)) {
        points.push(num);
      }
    }
    return points;
  }

  private contains(source: Vector3[], point: Vector3): boolean {
    for (const child of source) {
      if (MathUtils.equalsNumber3D(child, point)) {
        return true;
      }
    }
    return false;
  }
}
